/*
  Lagar prisfiltret när valutaformatet använder mellanslag som tusentalsavgränsare.

  BAKGRUND
  Butikens format är {{amount_no_decimals_with_space_separator}} kr, vilket ger
  "2 599 kr". Temats snippet collection-grid-filters-form.liquid gör så här:

      filter.max_value.value | money_without_currency | replace: ',', ''

  Den plockar bort komma men inte mellanslag. Med det gamla amerikanska formatet
  blev "2,599.00" till "2599.00" och allt fungerade. Med svenskt format blir
  "2 599" kvar som det är, och parseFloat läser det som 2. Resultatet blev ett
  prisreglage som gick från 0 till 2 kronor.

  OBS om attributen
  Shopify lämnar data-min, data-min-value och data-max-value tomma när kunden
  inte filtrerat ännu. Bara data-max har ett värde. Tomt minvärde betyder noll,
  tomt maxvärde betyder hela intervallet.

  LÖSNING
  Vi läser värdena ur data-attributen, tolkar dem korrekt genom att ta bort alla
  sorters mellanslag, och startar om reglaget med rätt intervall.

  Alternativet var att skriva om snippetet på 16 kB för hand, vilket har högre
  risk för slarvfel. Ändras temat bör fixen flyttas dit i stället.
*/
(function () {
  'use strict';

  function toNumber(raw) {
    if (raw === null || raw === undefined) return null;
    var cleaned = String(raw)
      .replace(/[\s  ]/g, '')
      .replace(/[^0-9.,]/g, '')
      .replace(/,/g, '');
    if (cleaned === '') return null;
    var n = parseFloat(cleaned);
    return isNaN(n) ? null : n;
  }

  function fixOne(wrap) {
    var slider = wrap.querySelector('.price-range__slider');
    if (!slider || !slider.noUiSlider) return;

    var rangeMax = toNumber(wrap.getAttribute('data-max'));
    if (rangeMax === null || rangeMax <= 0) return;

    // Tomt betyder noll respektive hela intervallet.
    var rangeMin = toNumber(wrap.getAttribute('data-min'));
    if (rangeMin === null) rangeMin = 0;

    var valueMin = toNumber(wrap.getAttribute('data-min-value'));
    if (valueMin === null) valueMin = rangeMin;

    var valueMax = toNumber(wrap.getAttribute('data-max-value'));
    if (valueMax === null) valueMax = rangeMax;

    if (rangeMax <= rangeMin) return;

    var current = slider.noUiSlider.options.range;
    if (current && current.min === rangeMin && current.max === rangeMax) return;

    slider.noUiSlider.updateOptions({
      range: { min: rangeMin, max: rangeMax },
      start: [valueMin, valueMax]
    }, true);

    slider.noUiSlider.set([valueMin, valueMax]);
  }

  function fix() {
    // Det finns två, en i sidokolumnen och en i filterlådan på mobil.
    document.querySelectorAll('.price-range').forEach(fixOne);
  }

  function boot() {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var s = document.querySelector('.price-range__slider');
      if (s && s.noUiSlider) {
        fix();
        clearInterval(timer);
      } else if (tries > 40) {
        clearInterval(timer);
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Kollektionssidan laddar om rutnätet med ajax vid filtrering.
  document.addEventListener('collection:reloaded', boot);
})();
